import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../api/client";
import { useAsync } from "../lib/useAsync";
import { useAuth } from "../auth/AuthContext";
import type { RsvpStatus } from "../api/types";

export function InviteLanding() {
  const { token = "" } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated, login } = useAuth();
  const { data, loading, error } = useAsync(
    () => api.resolveInvite(token),
    [token],
  );
  const [msg, setMsg] = useState<string>();

  const accept = async (rsvp: RsvpStatus) => {
    setMsg(undefined);
    try {
      const res = await api.acceptInvite(token, rsvp);
      navigate(`/meets/${res.meetId}`);
    } catch (e) {
      setMsg((e as Error).message);
    }
  };

  if (loading) return <p>Loading…</p>;
  if (error) return <p className="error">{error}</p>;

  const meet = data?.meet;
  return (
    <div className="card">
      <h1>{meet?.title}</h1>
      <p className="muted">
        {meet && new Date(meet.startAt).toLocaleString()} · {meet?.venueName}
      </p>
      <p className="muted">
        {meet?.address.line1}, {meet?.address.city}, {meet?.address.state}
      </p>

      {isAuthenticated ? (
        <div className="row">
          <button onClick={() => accept("GOING")}>I'm going</button>
          <button className="secondary" onClick={() => accept("MAYBE")}>
            Maybe
          </button>
          <button className="secondary" onClick={() => accept("NOT_GOING")}>
            Can't make it
          </button>
        </div>
      ) : (
        <div className="row">
          <button onClick={() => login()}>Sign in to RSVP</button>
          <button className="secondary" onClick={() => login("Google")}>
            Sign in with Google
          </button>
        </div>
      )}
      {msg && <p className="error">{msg}</p>}
    </div>
  );
}
